import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base'
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web'
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http'
import { registerInstrumentations } from '@opentelemetry/instrumentation'
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch'
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request'
import { resourceFromAttributes } from '@opentelemetry/resources'
import {
  ATTR_DEPLOYMENT_ENVIRONMENT_NAME,
  ATTR_SERVICE_NAME,
  ATTR_SERVICE_VERSION,
} from '@opentelemetry/semantic-conventions'

let initialized = false

export function initializeTelemetry() {
  if (!import.meta.env.PROD || initialized) return
  initialized = true

  const exporter = new OTLPTraceExporter({
    url: '/otel/v1/traces',
  })
  const provider = new WebTracerProvider({
    resource: resourceFromAttributes({
      [ATTR_SERVICE_NAME]: 'qualiq-frontend',
      [ATTR_SERVICE_VERSION]: import.meta.env.VITE_APP_VERSION ?? 'unknown',
      [ATTR_DEPLOYMENT_ENVIRONMENT_NAME]: 'production',
    }),
    spanProcessors: [new BatchSpanProcessor(exporter)],
  })

  provider.register()
  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation({ propagateTraceHeaderCorsUrls: [/.*/] }),
      new XMLHttpRequestInstrumentation({ propagateTraceHeaderCorsUrls: [/.*/] }),
    ],
  })
}
